import './src/styles/preloader.scss'
import './src/styles/reset.scss'
import './src/styles/fonts.scss'
import './src/styles/general.scss'
import './src/styles/noscript.scss'
